"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerValidators = exports.UniqueDrivingLicenceNumberValidation = exports.UniqueDriverValidation = exports.AllDriversUniqueValidation = exports.NoUnderwritingRuleFailuresValidation = exports.VehicleRegistrationNumberValidation = exports.UniqueVehicleValidation = exports.PaymentDayChangePermissionValidation = exports.DrivingLicenceResolveValidation = exports.DrivingLicenceNumberValidation = void 0;
var DrivingLicenceNumberValidation_1 = require("./DrivingLicenceNumberValidation");
Object.defineProperty(exports, "DrivingLicenceNumberValidation", { enumerable: true, get: function () { return DrivingLicenceNumberValidation_1.DrivingLicenceNumberValidation; } });
var DrivingLicenceResolveValidation_1 = require("./DrivingLicenceResolveValidation");
Object.defineProperty(exports, "DrivingLicenceResolveValidation", { enumerable: true, get: function () { return DrivingLicenceResolveValidation_1.DrivingLicenceResolveValidation; } });
var PaymentDayChangePermissionValidation_1 = require("./PaymentDayChangePermissionValidation");
Object.defineProperty(exports, "PaymentDayChangePermissionValidation", { enumerable: true, get: function () { return PaymentDayChangePermissionValidation_1.PaymentDayChangePermissionValidation; } });
var UniqueVehicleValidation_1 = require("./UniqueVehicleValidation");
Object.defineProperty(exports, "UniqueVehicleValidation", { enumerable: true, get: function () { return UniqueVehicleValidation_1.UniqueVehicleValidation; } });
var VehicleRegistrationNumberValidation_1 = require("./VehicleRegistrationNumberValidation");
Object.defineProperty(exports, "VehicleRegistrationNumberValidation", { enumerable: true, get: function () { return VehicleRegistrationNumberValidation_1.VehicleRegistrationNumberValidation; } });
var NoUnderwritingRuleFailuresValidation_1 = require("./NoUnderwritingRuleFailuresValidation");
Object.defineProperty(exports, "NoUnderwritingRuleFailuresValidation", { enumerable: true, get: function () { return NoUnderwritingRuleFailuresValidation_1.NoUnderwritingRuleFailuresValidation; } });
var AllDriversUniqueValidation_1 = require("./AllDriversUniqueValidation");
Object.defineProperty(exports, "AllDriversUniqueValidation", { enumerable: true, get: function () { return AllDriversUniqueValidation_1.AllDriversUniqueValidation; } });
var UniqueDriverValidation_1 = require("./UniqueDriverValidation");
Object.defineProperty(exports, "UniqueDriverValidation", { enumerable: true, get: function () { return UniqueDriverValidation_1.UniqueDriverValidation; } });
var UniqueDrivingLicenceNumberValidation_1 = require("./UniqueDrivingLicenceNumberValidation");
Object.defineProperty(exports, "UniqueDrivingLicenceNumberValidation", { enumerable: true, get: function () { return UniqueDrivingLicenceNumberValidation_1.UniqueDrivingLicenceNumberValidation; } });
var VehicleExclusiveRegistrationNumberValidation_1 = require("./VehicleExclusiveRegistrationNumberValidation");
var DrivingLicenceLookupValidation_1 = require("./DrivingLicenceLookupValidation");
var AnnualHomeAddressValidation_1 = require("./AnnualHomeAddressValidation");
function registerValidators(journeyComponentsManager) {
    journeyComponentsManager.addValidation({
        id: "drivingLicenceResolve",
        method: DrivingLicenceResolveValidation_1.DrivingLicenceResolveValidation
    });
    journeyComponentsManager.addValidation({
        id: "uniqueVehicle",
        method: UniqueVehicleValidation_1.UniqueVehicleValidation
    });
    journeyComponentsManager.addValidation({
        id: "uniqueDriver",
        method: UniqueDriverValidation_1.UniqueDriverValidation
    });
    journeyComponentsManager.addValidation({
        id: "allDriversUnique",
        method: AllDriversUniqueValidation_1.AllDriversUniqueValidation
    });
    journeyComponentsManager.addValidation({
        id: "drivingLicenceNumber",
        method: DrivingLicenceNumberValidation_1.DrivingLicenceNumberValidation
    });
    journeyComponentsManager.addValidation({
        id: "drivingLicenceLookup",
        method: DrivingLicenceLookupValidation_1.DrivingLicenceLookupValidation
    });
    journeyComponentsManager.addValidation({
        id: "uniqueDrivingLicenceNumber",
        method: UniqueDrivingLicenceNumberValidation_1.UniqueDrivingLicenceNumberValidation
    });
    journeyComponentsManager.addValidation({
        id: "paymentDayChangePermission",
        method: PaymentDayChangePermissionValidation_1.PaymentDayChangePermissionValidation
    });
    journeyComponentsManager.addValidation({
        id: "vehicleRegistrationNumber",
        method: VehicleRegistrationNumberValidation_1.VehicleRegistrationNumberValidation
    });
    journeyComponentsManager.addValidation({
        id: "noUnderwritingRuleFailures",
        method: NoUnderwritingRuleFailuresValidation_1.NoUnderwritingRuleFailuresValidation
    });
    journeyComponentsManager.addValidation({
        id: "vehicleExclusiveRegistrationNumberValidation",
        method: VehicleExclusiveRegistrationNumberValidation_1.VehicleExclusiveRegistrationNumberValidation
    });
    journeyComponentsManager.addValidation({
        id: "annualHomeAddressValidation",
        method: AnnualHomeAddressValidation_1.AnnualHomeAddressValidation
    });
}
exports.registerValidators = registerValidators;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/validations/index.js
// module id = 2528
// module chunks = 0